import { render, staticRenderFns } from "./DashboardNumbers.vue?vue&type=template&id=6a21c6a4&scoped=true&"
import script from "./DashboardNumbers.vue?vue&type=script&lang=js&"
export * from "./DashboardNumbers.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNumbers.vue?vue&type=style&index=0&id=6a21c6a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a21c6a4",
  null
  
)

export default component.exports